import { render, staticRenderFns } from "./DnProperties.vue?vue&type=template&id=50654976&functional=true&"
import script from "./DnProperties.vue?vue&type=script&lang=js&"
export * from "./DnProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports